import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export const PublicRoute = ({ children }) => {
    const navigate = useNavigate();
    
    useEffect(() => {
      // Check if user is already logged in
      const token = localStorage.getItem('token');
      if (token) {
        // Redirect to dashboard if logged in
        navigate('/dashboard');
      }
    }, [navigate]);
  
    // Only render children (login/register) if no token exists
    return !localStorage.getItem('token') ? children : null;
};